import Vue from 'vue'
import VueFilterDateParse from '@vuejs-community/vue-filter-date-parse'
import VueFilterDateFormat from '@vuejs-community/vue-filter-date-format'

Vue.use(VueFilterDateParse)
Vue.use(VueFilterDateFormat)
